import { FC, memo } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import clsx from 'clsx'

import Auth from 'store/auth'
import BtnLecturSubscribe from '../btn-lectur-subscribe/btn-lectur-subscribe'
import usePCWindow from 'hooks/usePCWindow'

import { generateLectorTumbnail } from 'utils/genereateLectorTumbnail'
import { cutHashFromURL } from 'utils/getURLData'
import { IAuthorLectorInfo, IAuthorLector } from './author-lector.types'
import { popupName } from 'constants/auth/auth-data'
import { Pathname, STATIC_URL, generateBaseStaticWidthURL } from 'constants/data'
import { Tag } from 'constants/tags'
import { ScreenSize } from 'constants/media-constanst'
import { A_LOG_REG_HASH, originRegWebinars } from 'utils/analytics/other/registration/registration'
import ButtonThemes from '../button/themes'

import styles from './author-lector.module.scss'

const imgPath = {
  preview: `${STATIC_URL}/lector-card/lectorPlug.png`,
}

const AuthLectorInfo: FC<IAuthorLectorInfo> = ({
  lectorData,
  withRegalia,
  nameModificator,
}: IAuthorLector) => {
  const { id, lastName, firstName, secondName, previewName, small, big, tags, regalia } = lectorData
  const { basePath } = useRouter()
  const isMobile = usePCWindow(ScreenSize.mobile)

  const emptyRegalia = withRegalia && !regalia

  const lectorPreview = previewName ? (
    <img
      src={`${basePath}${generateBaseStaticWidthURL(300)}/lectur/${previewName}`}
      className={clsx(styles.avatar, {
        [styles.avatarBig]: big,
      })}
      decoding="async"
      loading="lazy"
      alt="автор материала"
    />
  ) : (
    <img
      src={imgPath.preview}
      className={clsx(styles.avatar, {
        [styles.avatarBig]: big,
      })}
      decoding="async"
      loading="lazy"
      alt="автор материала"
    />
  )

  return (
    <>
      <div
        className={clsx(styles.author, {
          [styles.authorWithLink]: id,
          [styles.wrapWithRegalia]: withRegalia,
          [styles.wrapWithRegaliaButEmpty]: emptyRegalia,
          [styles.withRegaliaSlim]: withRegalia && regalia && regalia.length < 110,
        })}
      >
        {lectorPreview}
        <div
          className={clsx({
            [nameModificator as string]: nameModificator,
          })}
        >
          <div
            className={clsx(styles.authorName, {
              [styles.withRegalia]: withRegalia,
            })}
          >
            <span>{lastName}</span>{' '}
            <span className={styles.noWrapAuthor}>
              <span>{firstName}</span> <span>{secondName}</span>
            </span>
          </div>
          {withRegalia && !isMobile && regalia && <div className={styles.regalia}>{regalia}</div>}
        </div>
      </div>
      {withRegalia && isMobile && regalia && <div className={styles.regalia}>{regalia}</div>}
    </>
  )
}

const AuthorLector: FC<IAuthorLector> = ({
  lectorData,
  withLink,
  withRegalia,
  modificator,
  isVertical,
  nameModificator,
  subscribeLector,
  origin,
}: IAuthorLector) => {
  const router = useRouter()
  const { isAuthorized, fakeAuth } = Auth.useAuth()

  const path = cutHashFromURL(router.asPath)

  const { id, linkTranslation, subscribed = false } = lectorData

  const subscribeLectur = async () => {
    if (isAuthorized && !fakeAuth && subscribeLector) {
      await subscribeLector(id as number)
    } else {
      sessionStorage.setItem(A_LOG_REG_HASH, originRegWebinars.SUBLECTOR)
      router.push(`${path}#${popupName.registration}`, undefined, { shallow: true })
    }
  }

  // const hidden = tags?.includes(Tag.hidden)

  return (
    <div
      className={clsx(styles.authorCard, {
        [modificator as string]: modificator,
        [styles.authorCardVertical as string]: isVertical,
      })}
    >
      {withLink && id ? (
        <Link href={`/${Pathname.LECTURE}/${linkTranslation || id}`}>
          <AuthLectorInfo
            lectorData={lectorData}
            nameModificator={nameModificator}
            withRegalia={withRegalia}
          />
        </Link>
      ) : (
        <AuthLectorInfo
          lectorData={lectorData}
          nameModificator={nameModificator}
          withRegalia={withRegalia}
        />
      )}
      {subscribeLector && (
        <div
          className={clsx(styles.buttons, {
            [styles.buttonsFull]: isVertical,
          })}
        >
          <div className={styles.button} onClick={subscribeLectur}>
            <BtnLecturSubscribe
              isSubscribed={subscribed}
              theme={ButtonThemes.SECOND}
              origin={origin}
              idLector={id}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default memo(AuthorLector)
